awardCalculation.classy.controller({
    name: 'LivingAllowanceController',
    inject: ['$scope', '$q', 'RestService', 'EditSumsService', 'FamilyThresholdsService', 'ApplicationService', 'CalculationService', 'ModelService', 
            'BinFactory', 'TabsService', 'SliderService', 'SliderFactory', 'DateService', 'ResetService'],
    init: function()
    {
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.DateService = this.DateService;
        this.$.TabsService = this.TabsService;
        this.$.ResetService = this.ResetService;
    },
    livingAllowancePut: function(scope, instance, form)
    {
        instance.options.factor  = .3;
        var parent = this;
        var dataThresh = this.ApplicationService.getFamilyData().thresholds;
        var dataEditSums = this.ApplicationService.getFamilyData().edit_sums;

        var putDataThresh = {};
        var putDataEditSums = {};

        putDataThresh.Thresh_Living_Allowance = dataThresh.Thresh_Living_Allowance;
        putDataThresh.Thresh_Allow_Per_Child = dataThresh.Thresh_Allow_Per_Child;

        putDataEditSums.Applicant_Count = dataEditSums.Applicant_Count;
        putDataEditSums.Child_Count = dataEditSums.Child_Count;
        putDataEditSums.Exp_Added = dataEditSums.Exp_Added;

        putDataThresh.familyID = dataThresh.familyID;
        putDataThresh.applicationID = dataEditSums.applicationID;
        putDataEditSums.familyID = dataEditSums.familyID;
        putDataEditSums.applicationID = dataEditSums.applicationID;
        return this.$q.all([
                this.EditSumsService.put(putDataEditSums),
                this.FamilyThresholdsService.put(putDataThresh)
            ]).then(function (data, status, headers, config) {
            parent.CalculationService.reCalc();
            var works = 0;
            if (data[0].status == 200) 
                works++;
            if (data[1].status == 200)
                works++;
            if (works > 0)
                instance.stop(1);
            else
                instance.stop(-1);
            //instance.options.callMe(data, status, headers, config, instance);
        });

    },
    setLivingAllowanceOpen: function(bool)
    {
        if (this.ApplicationService.isFamilyTwoSituation())
            this.$.livingAllowanceOpen = bool;
        else
            this.$.livingAllowanceOpen = false;
    },
    toggleAllowances: function(value)
    {
        if (value==true) 
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/addedAllowances', 'Added Allowances', 's'));
        else
            this.SliderService.pushSlider(new this.SliderFactory('tabs/submodules/awardCalculation/partials/livingAllowance', 'Living Allowance', 's'));
	    this.$.allowancesOpen = !this.$.allowancesOpen;
   }
});
